<template>
    <o-form :title="$t('sandoz.wholesaler')" :url="`/api/wholesalers/${$route.params.id}`" class="ortic-form-horizontal mb-4" ref="form">
        <template slot-scope="props">
            <b-row>
                <b-col>
                  <o-input :label="$t('sandoz.wholesaler')" errorField="wholesaler" v-model="props.item.wholesaler"/>
                  <o-checkbox :errorField="'enabled_for_kuko'" :label="$t('sandoz.enabled_for_kuko')" v-model="props.item.enabled_for_kuko"/>
                  <o-checkbox :errorField="'enable_for_pass_through'" :label="$t('sandoz.enable_for_pass_through')"
                              v-model="props.item.enable_for_pass_through"/>
                  <o-checkbox :errorField="'enabled_for_chargebacks'" :label="$t('sandoz.enabled_for_chargebacks')"
                              v-model="props.item.enabled_for_chargebacks"/>
                  <o-input v-if="props.item.enabled_for_kuko" :label="$t('sandoz.dwh_name')" errorField="dwh_name" v-model="props.item.dwh_name"/>
                  <o-input v-if="props.item.enabled_for_kuko" type="email" :label="$t('sandoz.kuko_recipient')" errorField="kuko_recipient" v-model="props.item.kuko_recipient"/>
                  <o-value-select :label="$t('sandoz.kuko_excel_attachment')" v-model="props.item.excel_attachment" :items="attachmentTypes"/>
                  <o-value-select :items="languages" :label="$t('sandoz.language')" v-model="props.item.language"/>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
        </template>
    </o-form>
</template>

<script>
export default {
  data: () => ({
    attachmentTypes: [],
    languages: []
  }),
  created() {
    this.attachmentTypes.push({value: 'voigt', text: 'Voigt'})
    this.attachmentTypes.push({value: 'amedis', text: 'Amedis'})

    this.languages = [
      {value: 'de', text: 'DE'},
      {value: 'en', text: 'EN'},
      {value: 'fr', text: 'FR'},
      {value: 'it', text: 'IT'}
    ]
  }
}
</script>
